import LazyLoad from "vanilla-lazyload";

export default {
    init() {
        const lazyContent = new LazyLoad({
            use_native: true
        });
    }
}